// extracted by mini-css-extract-plugin
module.exports = {"svg":"SvgResource_svg__3NN2d"};